import { InfoCircle } from 'iconoir-react';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from '@savgroup-front-common/primitive/ui/alert';
import { SuggestionConfidence } from '@savgroup-front-common/types/CompanyDirectory';

import messages from './messages';
import { CONFIDENCE_MESSAGES } from './ProfileSummary.constants';

interface ProfileSummaryProps {
  summary?: string;
  confidence?: SuggestionConfidence;
}

export function ProfileSummary({ summary, confidence }: ProfileSummaryProps) {
  if (!summary) {
    return undefined;
  }

  const confidenceMessage = confidence
    ? CONFIDENCE_MESSAGES[confidence]
    : undefined;

  return (
    <Alert className="mb-8" data-testid="OnboardingActivities-summary">
      <InfoCircle aria-hidden className="size-4" />
      <AlertTitle>
        <h2>
          <SafeFormattedMessageWithoutSpread message={messages.title} />
        </h2>
      </AlertTitle>
      <AlertDescription>
        <p>{summary}</p>
        {!!confidenceMessage && (
          <p className="text-xs">
            <SafeFormattedMessageWithoutSpread message={confidenceMessage} />
          </p>
        )}
      </AlertDescription>
    </Alert>
  );
}
